<template>
  <div id="app">
    <Drone />
    <Kraken />
    <Navbar ref="homenavbar" />
    <main>
      <BlackBoxLoader>
        <router-view :key="$route.fullPath"></router-view>
      </BlackBoxLoader>
    </main>
  </div>
</template>

<script>
import BlackBoxLoader from "@/components/BlackBoxLoader";
import Drone from "@/components/Drone";
import Kraken from "@/components/Kraken";
import Navbar from "@/components/Navbar";
export default {
  name: "AffakKhan",
  components: {
    BlackBoxLoader,
    Navbar,
    Kraken,
    Drone
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "primaryFont";
  src: url("./styles/fonts/SairaCondensed-Regular.ttf");
}

body {
  background: $lightPrimary;
  font-family: "primaryFont";
  color: $darkPrimary;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
